import { loadingStyles } from "../../styles/styles";
import { Backdrop, CircularProgress } from "@material-ui/core";
import { connect } from "react-redux";

function Loading(props) {
  const classes = loadingStyles();

  return (
    <Backdrop className={classes.backdrop} open={props.loading.show}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

const mapStateToProps = (state) => {
  return {
    loading: state.loading,
  };
};

export default connect(mapStateToProps)(Loading);
